import React, { useContext } from "react";
import { useApolloClient } from "react-apollo";
import PropTypes from "prop-types";
import { Title } from "rbx";
import { ModalContext } from "../ModalProvider";
import ActionButtons from "./ActionButtons";

const PageHeader = ({
  actionsType,
  title,
  name,
  editing,
  FilterComponent,
  filters,
  setFilters,
  onAddClick,
  onDeleteAllClick,
  onSaveClick,
  query,
  subheader,
  columns,
  where,
  readOnly,
  children,
  subTitle
}) => {
  const { setModalOpen } = useContext(ModalContext);
  const client = useApolloClient();
  return (
    <header className="page-head">
      <div className="page-head-start">
        <Title color="primary" size={subheader ? 4 : 3}>
          {title}
        </Title>
      </div>
      <ActionButtons
        FilterComponent={FilterComponent}
        client={client}
        columns={columns}
        editing={editing}
        filters={filters}
        name={name}
        query={query}
        readOnly={readOnly}
        setFilters={setFilters}
        setModalOpen={setModalOpen}
        size="small"
        type={actionsType}
        where={where}
        onAddClick={onAddClick}
        onDeleteAllClick={onDeleteAllClick}
        onSaveClick={onSaveClick}
      >
        {children}
      </ActionButtons>
      <div className="page-head-start">
        <Title subtitle color="primary" size={6}>
          {subTitle}
        </Title>
      </div>
    </header>
  );
};

PageHeader.propTypes = {
  subheader: PropTypes.bool,
  title: PropTypes.string,
  FilterComponent: PropTypes.node,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  onDeleteAllClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  query: PropTypes.object,
  name: PropTypes.string,
  onAddClick: PropTypes.func,
  editing: PropTypes.bool,
  columns: PropTypes.array,
  actionsType: PropTypes.string,
  where: PropTypes.object,
  readOnly: PropTypes.bool,
  children: PropTypes.node,
  subTitle: PropTypes.string
};

export default PageHeader;
